import * as Yup from "yup";

export const SchemaCustomerPassword = Yup.object().shape({
  oldPassword: Yup.string().required("Veuillez renseigner votre mot de passe actuel"),
  newPassword: Yup.string().required("Veuillez renseigner votre nouveau mot de passe")
    .min(12, "Le mot de passe doit contenir au moins 12 caractères")
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#%*?&])[A-Za-z\d@$!#%*?&]+$/, 'Le mot de passe doit contenir au moins une majuscule, une minuscule, un chiffre et un caractère spécial parmi cette liste : @, $, !, #, %, *, ?, &'),
  newPasswordConfirm: Yup.string().oneOf([Yup.ref("newPassword"), null], "Les mots de passe ne correspondent pas").required("Veuillez confirmer votre nouveau mot de passe"),
});